import Vue from 'vue';
import Router from 'vue-router';
// import store from './store';
// import useUserSummary from '@/store/useUserSummary';
import { getAuth } from 'firebase/auth';
import { isUser } from '@/store/useAuth';
// const { updateContextKey } = useUserSummary();

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'landingPage',
      component: () => import('./views/LandingPage')
    },
    {
      path: '/invite/:inviteId',
      name: 'invite',
      props: true,
      component: () => import('./views/LandingPage/invited'),
      beforeEnter(to, from, next) {
        console.log('test');
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          next();
        } else {
          next({ path: '/workspace/' });
        }
      }
    },
    {
      path: '/context/:contextId/:page?',
      name: 'context',
      component: () => import('./views/Context'),
      props: true
    },
    {
      path: '/context/',
      name: 'megaContext',
      component: () => import('./views/Context'),
      props: true,
      beforeEnter(to, from, next) {
        console.log('test');
        if (!isUser.value) {
          next({ path: '/login' });
        } else {
          next();
        }
      }
    },
    {
      path: '/newcontext',
      name: 'newContext',
      component: () => import('./components/NewContextGuide'),
      props: true
    },
    {
      path: '/',
      name: 'home',
      beforeEnter(to, from, next) {
        console.log('test', isUser);
        if (!isUser.value) {
          next({ path: '/login' });
        } else {
          next({ path: '/context/' });
          // if (store.getters['auth/lastWorkspaceId']) {
          //   //store.commit('userWorkspaceLite/setWorkspaceId', store.getters["auth/lastWorkspaceId"]);
          //   next({ path: '/workspace/' + store.getters['auth/lastWorkspaceId'] });
          // } else {
          //   next({ path: '/workspace/0' });
          // }
        }

        // store
        //   .dispatch('context/checkContextAccessPersmissions', to.params.contextId)
        //   .then(() => {
        //     console.log('allowed');
        //     next();
        //   })
        //   .catch(e => {
        //     console.log('not allowed', e);
        //     next({ path: '/login' });
        //   });
      }
    },
    {
      path: '/mystuff',
      name: 'workspace',
      component: () => import('./views/Dashboard'),
      props: true,
      beforeRouteEnter(to, from, next) {
        next(); //  check workspace permission
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('./views/Dashboard/DashboardOverview.vue')
        }
        // {
        //   path: 'projects',
        //   name: 'projects',
        //   component: () => import('./views/Dashboard/AllProjects')
        // },
        // {
        //   path: 'history',
        //   name: 'history',
        //   component: () => import('./views/Dashboard/WorkspaceHistory')
        // }
      ]
    }
  ]
});

router.afterEach((to, from) => {
  if (to.name === 'context' && from.params.contextId != to.params.contextId) {
    //  update last opened
  }
});

router.beforeEach(async (to, from, next) => {
  if (from.params.contextId == to.params.contextId) {
    return next();
  }
  if (from.name === 'context') {
    console.log(`from ${from.params.contextId}`);
    // await store.dispatch('components/sessionStorage/updateStoredContext', {
    //   contextId: from.params.contextId
    // });
  }
  if (to.name === 'context') {
    return next();
  }
});
export default router;
